import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp, GripVertical, Loader2, RotateCcw, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const move = (arr, from, to) => {
  if (to < 0 || to >= arr.length || from === to) return arr;
  const a = [...arr];
  const [x] = a.splice(from, 1);
  a.splice(to, 0, x);
  return a;
};

const SortList = ({ id, title, items, onChange }) => {
  const [drag, setDrag] = useState(null);
  return (
    <div data-testid={`order-list-${id}`}>
      <p className="mb-2 text-sm font-semibold">{title}</p>
      <ol className="space-y-1.5">
        {items.map((it, i) => (
          <li key={it.key} draggable data-testid={`order-${id}-${it.key}`}
            onDragStart={() => setDrag(i)} onDragOver={(e) => e.preventDefault()}
            onDrop={() => { onChange(move(items, drag, i)); setDrag(null); }}
            className={`flex cursor-grab items-center gap-2 rounded-lg border bg-background px-3 py-2 text-sm transition-colors hover:bg-muted ${drag === i ? "opacity-50" : ""}`}>
            <GripVertical className="h-4 w-4 text-muted-foreground" />
            <span className="w-5 font-num text-xs text-muted-foreground">{i + 1}</span>
            <span className="flex-1">{it.label}</span>
            <button type="button" aria-label="Naik" data-testid={`order-${id}-${it.key}-up`} disabled={i === 0}
              onClick={() => onChange(move(items, i, i - 1))} className="rounded p-1 hover:bg-muted-foreground/10 disabled:opacity-30"><ArrowUp className="h-3.5 w-3.5" /></button>
            <button type="button" aria-label="Turun" data-testid={`order-${id}-${it.key}-down`} disabled={i === items.length - 1}
              onClick={() => onChange(move(items, i, i + 1))} className="rounded p-1 hover:bg-muted-foreground/10 disabled:opacity-30"><ArrowDown className="h-3.5 w-3.5" /></button>
          </li>
        ))}
      </ol>
    </div>
  );
};

export const LayoutOrderCard = () => {
  const [lay, setLay] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/ringkasan-order").then((r) => setLay(r.data)); }, []);
  const call = async (fn, msg) => {
    setBusy(true);
    try { setLay((await fn()).data); toast.success(msg); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const save = () => call(() => api.put("/settings/ringkasan-order",
    { cards: lay.cards.map((x) => x.key), blocks: lay.blocks.map((x) => x.key) }), "Urutan Ringkasan disimpan");
  const reset = () => call(() => api.delete("/settings/ringkasan-order"), "Urutan dikembalikan ke default");

  return (
    <div data-testid="layout-order-card" className="rounded-xl border bg-card p-5 shadow-sm">
      <h3 className="font-heading text-lg font-semibold">Urutan Kartu & Grafik Ringkasan</h3>
      <p className="text-sm text-muted-foreground">Seret (drag) atau gunakan tombol panah. Urutan berlaku di halaman Ringkasan, PDF, dan PPT Laporan/Rapor.</p>
      {!lay ? <Loader2 className="mt-4 h-5 w-5 animate-spin" /> : (
        <div className="mt-4 grid gap-6 md:grid-cols-2">
          <SortList id="cards" title="Kartu KPI" items={lay.cards} onChange={(cards) => setLay({ ...lay, cards })} />
          <SortList id="blocks" title="Grafik & Tabel" items={lay.blocks} onChange={(blocks) => setLay({ ...lay, blocks })} />
        </div>
      )}
      <div className="mt-4 flex gap-2">
        <Button data-testid="layout-order-save" onClick={save} disabled={busy || !lay}><Save className="mr-1 h-4 w-4" />Simpan Urutan</Button>
        <Button data-testid="layout-order-reset" variant="outline" onClick={reset} disabled={busy}><RotateCcw className="mr-1 h-4 w-4" />Default</Button>
      </div>
    </div>
  );
};
